const Environments = {
  DOMAIN_URL: process.env.REACT_APP_DOMAIN_URL,
  COOKIE_HASH: process.env.REACT_APP_COOKIE_HASH!,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL!,
  EDUCATION_SERVICE_URL: process.env.REACT_APP_EDUCATION_SERVICE_URL!,
  SERVICESETUP_URL: process.env.REACT_APP_SERVICESETUP_URL!,
  PERFORMANCE_SERVICE_URL: process.env.REACT_APP_PERFORMANCE_URL!,
  RECEIVABLE_MANAGEMENT_SERVICE_URL:
    process.env.REACT_APP_RECEIVABLE_MANAGEMENT_SERVICE_URL!,
  IDENTITY_CARD_SERVICE_URL: process.env.REACT_APP_IDENTITY_CARD_URL!,

  GOOGLE_MAPS_API_KEY: "AIzaSyCn16FR8HOz8edmzr5H4eji9FW1FGFSEw4",
};

export default Environments;
